import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import pick from 'lodash/pick';
import isEmpty from 'lodash/isEmpty';
import { COLUMN_SHAPE } from './Column';

var getColumnsFromElements = function getColumnsFromElements(elements) {
  var columns = [];
  elements.forEach(function (element) {
    if (!element || !React.isValidElement(element)) {
      return;
    }

    var column = pick(element.props, Object.keys(COLUMN_SHAPE));

    if (element.key) {
      column.key = element.key;
    }

    columns.push(column);
  });
  return columns;
};

export var normalizeColumns = function normalizeColumns(columns, elements) {
  if (!columns) {
    columns = elements ? getColumnsFromElements(elements) : [];
  }

  return columns.map(function (column, index) {
    return _objectSpread(_objectSpread({}, column), {}, {
      key: column.key || column.path || index
    });
  });
};
export var isValidCellText = function isValidCellText(text) {
  return !(!!text && !React.isValidElement(text) && Object.prototype.toString.call(text) === '[object Object]');
};
export var isEmptyNode = function isEmptyNode(node) {
  return isEmpty(node) && typeof node !== 'number';
};